import React, { useEffect, useState } from "react";
import { Scale, Save, Loader2, Eye } from "lucide-react";
import { getLegalSettings, updateLegalSettings } from "../../../api";
import { useToast } from "../../../hooks/use-toast";
import { log } from "../../../lib/log";

const FIELDS = [
  ["denomination", "Dénomination sociale"], ["forme", "Forme juridique"], ["capital", "Capital social"], ["adresse", "Siège social"],
  ["siret", "SIRET"], ["rcs", "Immatriculation (RCS)"], ["tva", "TVA intracommunautaire"], ["directeur", "Directeur de la publication"],
  ["telephone", "Téléphone (affiché)"], ["email", "Email de contact"], ["assureur", "Assurance RC Pro (assureur, n° police, zone)"],
];
const inputCls = "w-full border border-neutral-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-brand disabled:bg-neutral-50";

/** Informations légales affichées sur /mentions-legales (édition master). */
const LegalEditor = ({ isMaster }) => {
  const [f, setF] = useState(null);
  const [saving, setSaving] = useState(false);
  const { toast } = useToast();
  useEffect(() => { getLegalSettings().then((r) => setF(r.data)).catch((e) => log.error("legal:", e)); }, []);

  const save = async () => {
    setSaving(true);
    try { const r = await updateLegalSettings(f); setF(r.data); toast({ title: "Informations légales enregistrées ✓" }); }
    catch (e) { toast({ title: "Erreur", description: e?.response?.data?.detail || "Échec", variant: "destructive" }); }
    finally { setSaving(false); }
  };

  return (
    <div className="bg-white border border-neutral-200 rounded-xl p-4 mb-5" data-testid="legal-editor">
      <div className="flex flex-wrap items-center gap-3 mb-3">
        <Scale size={18} className="text-brand" />
        <p className="font-semibold text-neutral-900 text-sm">Informations légales</p>
        <a href="/mentions-legales" target="_blank" rel="noreferrer" className="text-xs text-brand hover:underline flex items-center gap-1"><Eye size={12} /> /mentions-legales</a>
        {!isMaster && <span className="text-xs text-neutral-400">(modification réservée au super-admin)</span>}
      </div>
      {!f ? <p className="text-sm text-neutral-400 flex items-center gap-2"><Loader2 size={14} className="animate-spin" /> Chargement…</p> : (<>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {FIELDS.map(([k, label]) => (
            <label key={k} className={k === "assureur" ? "sm:col-span-2 lg:col-span-3" : ""}><span className="block text-[11px] font-semibold text-neutral-500 mb-1">{label}</span>
              <input className={inputCls} value={f[k] || ""} disabled={!isMaster} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`legal-input-${k}`} /></label>
          ))}
        </div>
        {isMaster && <div className="flex justify-end mt-3"><button onClick={save} disabled={saving} className="flex items-center gap-1.5 bg-brand hover:bg-brand-dark text-white text-sm font-semibold px-4 py-2 rounded-md disabled:opacity-60" data-testid="legal-save">{saving ? <Loader2 size={14} className="animate-spin" /> : <Save size={14} />} Enregistrer</button></div>}
      </>)}
    </div>
  );
};

export default LegalEditor;
